(function() {
  function hideChatOnDrawer() {
    var details = document.getElementById('Details-menu-drawer-container');
    if (!details) {
      setTimeout(hideChatOnDrawer, 500);
      return;
    }

    var drawerWatcher = new MutationObserver(function() {
      var isOpen = details.classList.contains('menu-open');

      // Target only the chat iframe — no id, no src, direct child of body
      document.querySelectorAll('iframe').forEach(function(iframe) {
        if (!iframe.id && !iframe.src) {
          if (isOpen) {
            iframe.style.setProperty('visibility', 'hidden', 'important');
            iframe.style.setProperty('opacity', '0', 'important');
            iframe.style.setProperty('pointer-events', 'none', 'important');
          } else {
            iframe.style.removeProperty('visibility');
            iframe.style.removeProperty('opacity');
            iframe.style.removeProperty('pointer-events');
          }
        }
      });
    });

    drawerWatcher.observe(details, {
      attributes: true,
      attributeFilter: ['class', 'open']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hideChatOnDrawer);
  } else {
    hideChatOnDrawer();
  }
})();